import type { ExternalEmbed } from '../../lib/embeds/types';

export function ExternalArticleEmbed({ url, title, description, favicon, thumbnail }: ExternalEmbed) {
  return (
    <a
      className="embed embed-external"
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        display: 'flex',
        gap: '12px',
        alignItems: 'center',
        border: '1px solid #ff5a00',
        borderRadius: 12,
        padding: 12,
        textDecoration: 'none'
      }}
    >
      {thumbnail ? (
        <div style={{ width: 88, height: 88, position: 'relative', flexShrink: 0 }}>
          <img
            src={thumbnail}
            alt={title || url}
            style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: 8 }}
          />
        </div>
      ) : null}
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
          {favicon ? (
            <img
              src={favicon}
              alt="favicon"
              style={{ width: 16, height: 16, objectFit: 'cover', borderRadius: 4 }}
              loading="lazy"
            />
          ) : null}
          <div style={{ color: '#111827', fontWeight: 600 }}>{title || url}</div>
        </div>
        {description ? (
          <div style={{ color: '#4b5563', fontSize: 14, lineHeight: 1.4 }}>{description}</div>
        ) : null}
      </div>
      <div style={{ flexShrink: 0 }}>
        <span
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '10px 14px',
            borderRadius: 10,
            background: '#ff5a00',
            color: '#ffffff',
            fontWeight: 600,
            fontSize: 14,
            minWidth: 80
          }}
        >
          Open
        </span>
      </div>
    </a>
  );
}
